import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const DISMISS_KEY = "pwa-install-dismissed-at";
const DISMISS_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export function InstallPrompt() {
  const { lang } = useI18n();
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      const dismissedAt = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      if (Date.now() - dismissedAt < DISMISS_MS) return;
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!visible || !deferred) return null;
  const label = lang === "ar" ? "ثبّت التطبيق للوصول السريع" : "Install for quick access";
  const cta = lang === "ar" ? "تثبيت" : "Install";
  const install = async () => {
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setVisible(false);
  };
  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div className="fixed top-20 inset-x-4 z-50 mx-auto max-w-md">
      <div className="glass rounded-2xl p-3 flex items-center gap-3 shadow-xl shadow-primary/20 border border-primary/30">
        <div className="w-10 h-10 rounded-xl bg-primary text-white grid place-items-center shrink-0">
          <Download className="w-5 h-5" />
        </div>
        <p data-testid="pwa-install-label" className="flex-1 text-sm font-medium">{label}</p>
        <button data-testid="pwa-install-btn" onClick={install}
          className="px-3 py-1.5 rounded-xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90">
          {cta}
        </button>
        <button data-testid="pwa-install-dismiss" onClick={dismiss} className="p-1.5 rounded-lg hover:bg-warn/10 hover:text-warn">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
